import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { BRAND_LOGO_PATH } from "@/utils/constants";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const result = await login(email, password);
      if (result.success) {
        navigate("/dashboard");
      } else {
        setError(result.error || "Invalid credentials");
      }
    } catch (err) {
      setError("An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex">
      {/* Left Side - Hero Image */}
      <div
        className="hidden lg:flex lg:w-1/2 bg-cover bg-center relative"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1551024195-9518d8e3fdb8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwxfHxhZXJpYWwlMjBiZWFjaCUyMG9jZWFuJTIwdHJhdmVsfGVufDB8fHx8MTc2NDc2NTE5MHww&ixlib=rb-4.1.0&q=85')",
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-br from-secondary/95 via-accent/40 to-secondary/80" />
        <div className="relative z-10 flex flex-col justify-center p-12 text-white">
          <img
            src={BRAND_LOGO_PATH}
            alt="SafarCore"
            className="max-w-[280px] h-auto object-contain mb-8 drop-shadow-lg bg-white/95 rounded-xl p-4"
          />
          <h1 className="text-3xl font-heading font-bold mb-3 tracking-tight">
            Internal Operations Portal
          </h1>
          <p className="text-lg text-white/90 max-w-md">
            Travel operations, invoicing, and payments — built for teams who move
            the world.
          </p>
        </div>
      </div>

      {/* Right Side - Login Form */}
      <div className="flex-1 flex items-center justify-center p-6 bg-background">
        <div className="w-full max-w-md">
          <div className="mb-8 lg:hidden flex justify-center">
            <img
              src={BRAND_LOGO_PATH}
              alt="SafarCore"
              className="h-12 w-auto object-contain min-h-[48px]"
            />
          </div>
          <div className="mb-8">
            <h2 className="text-3xl font-heading font-semibold text-secondary mb-2">
              Welcome back
            </h2>
            <p className="text-stone-600">Sign in to your account</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6">
            {error && (
              <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg">
                {error}
              </div>
            )}

            <div>
              <label className="block text-sm font-medium text-stone-700 mb-2">
                Email
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="w-full bg-stone-50 border border-stone-200 focus:border-primary focus:ring-2 focus:ring-primary/20 rounded-lg h-10 px-4 transition-colors"
                placeholder="admin@travelco.com"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-stone-700 mb-2">
                Password
              </label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="w-full bg-stone-50 border border-stone-200 focus:border-primary focus:ring-2 focus:ring-primary/20 rounded-lg h-10 px-4 transition-colors"
                placeholder="••••••••"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-primary hover:bg-primary/90 text-white font-medium rounded-lg h-10 px-4 shadow-sm hover:shadow-md transition-all disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? "Signing in..." : "Sign in"}
            </button>
          </form>

          {/* <div className="mt-6 text-sm text-stone-500 text-center">
            <p>Default credentials:</p>
            <p className="font-mono text-xs mt-1">
              admin@travelco.com / admin123
            </p>
          </div> */}
        </div>
      </div>
    </div>
  );
}
